import * as React from "react";
import type { ReactNode } from "react";

import { Icon } from "../../../../Icons/Icon";
import { IconContainer } from "../ViewFile.styles";

import { ErrorIcon, WarningIcon } from "./AttachmentIcon.styles";

export interface AttachmentIconProps {
    error: boolean;
    warning: boolean;
}

export function AttachmentIcon(props: AttachmentIconProps): JSX.Element {
    let icon: ReactNode;
    if (props.error) {
        icon = (
            <ErrorIcon>
                <Icon name="MinusCircleIcon" />
            </ErrorIcon>
        );
    } else if (props.warning) {
        icon = (
            <WarningIcon>
                <Icon name="WarningTriangleIcon" />
            </WarningIcon>
        );
    } else {
        icon = <Icon name="DocIcon" />;
    }

    return <IconContainer>{icon}</IconContainer>;
}
